import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import React from 'react';
import Link from 'next/link';

import { SAFETY_FEATURE_STATUSES } from '../../constants/statuses';
import FallbackIcon, { iconNames } from '../icons';
import { H5, Small } from '../type';

import {
  DetailLink,
  InnerWrapper,
  RightColumnWrapper,
  StyledIcon,
  StyledStatusLabel,
  Wrapper,
  StatusIconWrapper,
} from './styles';

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'heading' implicitly has an 'any' type.
const FeatureTile = ({ iconUrl = '', heading, body, detailUrl = '', statusKey = '' }) => {
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ STANDARD: { labelText: string; Icon: ({ className, ...props }: { [x: string]: any; className: any; }) => Element; labelColor: string; databaseKey: string; }; NOT_INCLUDED: { labelText: string; Icon: ({ className, ...props }: { [x: string]: any; className: any; }) => Element; labelColor: string; }; OPTIONAL: { ...;...'.
  const { labelText, labelColor, Icon: StatusIcon } = statusKey && SAFETY_FEATURE_STATUSES[statusKey];

  const tile = (
    <InnerWrapper p={{ xs: 3, sm: 6 }} pr={{ xs: 4.5, sm: 9 }}>
      <Box mr={{ xs: 3, sm: 6 }}>
        {iconUrl ? (
          <StyledIcon src={iconUrl} />
        ) : (
          <FallbackIcon name={iconNames.safetyFeatureFallback} aria-hidden="true" />
        )}
      </Box>

      <RightColumnWrapper>
        <H5 as="h3">{heading}</H5>

        {statusKey ? (
          <Box mt={{ xs: 1.5, sm: 3 }}>
            <Box mr={1.5} display="inline">
              <StatusIconWrapper>
                <StatusIcon />
              </StatusIconWrapper>
            </Box>
            <StyledStatusLabel color={labelColor}>{labelText}</StyledStatusLabel>
          </Box>
        ) : null}

        <Box mt={{ xs: 1.5, sm: 3 }}>
          <Small>{body}</Small>
        </Box>

        {detailUrl ? (
          <Box mt={{ xs: 1.5, sm: 3 }}>
            <Link href={detailUrl}>
              <DetailLink>Read more about this feature</DetailLink>
            </Link>
          </Box>
        ) : null}
      </RightColumnWrapper>
    </InnerWrapper>
  );

  return <Wrapper>{tile}</Wrapper>;
};

FeatureTile.propTypes = {
  iconUrl: PropTypes.string,
  heading: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  detailUrl: PropTypes.string,
  statusKey: PropTypes.string,
};

export default FeatureTile;
